import React, { useMemo, useState } from 'react'
import { useAuthContext } from '../../context/auth.context'
import { useHistory } from '../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { useApiFormWhiteLabel } from '../../api-new/state/content'
import { useLoad } from '../../shared/hooks/load'

const logoPath = '/org/dashboard'
export const DEFAULT_LOGO = '/EDXR-Logo.png'

export const HeaderLogo = ({ small }) => {
  const history = useHistory()

  const authContext = useAuthContext()

  const apiFormWhiteLabel = useApiFormWhiteLabel()

  useLoad(
    async () => {
      try {
        if (authContext.state.organizationID) {
          await apiFormWhiteLabel.get(authContext.state.organizationID)
        }
      } catch {}
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [authContext.state]
  )

  // An organization's logo whose file is missing (a 404 from storage, e.g.
  // a key copied without its object) falls back to the EducationXR logo
  // instead of the browser's broken-image icon.
  const [failed, setFailed] = useState(null)

  const logo = useMemo(() => {
    const url = apiFormWhiteLabel.form.logoURL
    return url && url !== failed ? url : DEFAULT_LOGO
  }, [apiFormWhiteLabel.form, failed])

  const handleError = () => {
    if (logo !== DEFAULT_LOGO) setFailed(logo)
  }

  const handleClick = () => history.push(logoPath)

  return (
    <React.Fragment>
      <div className="d-inline" onClick={handleClick}>
        <img className={`edxr-pointer ${small ? 'logo-sm' : 'logo'}`} src={logo} alt="header logo" onError={handleError} />
      </div>
    </React.Fragment>
  )
}
